import { queryClient } from "@impero-com/common/utils/query_client";

import {
    getGetUsersUserIdControlEntitiesQueryKey,
    usePatchUsersUserIdControlEntities,
} from "api/generated/users/users";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useRemoveControlEntityRightsForUserMutation() {
    return usePatchUsersUserIdControlEntities({
        mutation: {
            onSuccess: async (_response, { userId }) => {
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey:
                            getGetUsersUserIdControlEntitiesQueryKey(userId),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
        },
    });
}
